import { toast, ToastContainer } from "react-toastify";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import { useCreateGameMutation } from "../../store/services/gameServices";
import DashboardHeader from "../DashboardHeader";
import { DateRangePicker } from "react-date-range";
import { enUS } from "react-date-range/dist/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { useLazyGetNACCodesQuery } from "../../store/services/nacServices";
import { cities } from "../notifications/AddNotification";
import { LuCheck } from "react-icons/lu";
import CreateGame from "./CreateGame";
import { serializeGameReceiptTypes } from '../../utils/receiptFields';

export const CreateCashback = () => {
  const [createGame] = useCreateGameMutation();
  const navigate = useNavigate()
  const [searchTextInput, setSearchTextInput] = useState('')
  const [nacCode, setNacCode] = useState(null)
  const [nacOptions, setNacOptions] = useState([])
  const debounceTimeoutRef = useRef(null);
  const [regions, setRegions] = useState(null)

  const [getNacCodes, { data: nacData }] = useLazyGetNACCodesQuery()

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      const start_date = values.dateRange[0].startDate
        ? new Date(values.dateRange[0].startDate).toLocaleDateString('en-CA', { timeZone: "Europe/Amsterdam" })
        : null;

      const end_date = values.dateRange[0].endDate
        ? new Date(values.dateRange[0].endDate).toLocaleDateString('en-CA', { timeZone: "Europe/Amsterdam" })
        : null;

      if (!values.isYearly && (!start_date || !end_date)) {
        toast.error("Zgjidhni një periudhë të vlefshme për lojën!");
        setSubmitting(false);
        return;
      }

      const gameData = new FormData();
      gameData.append('title', values.title);
      gameData.append('description', values.description);
      gameData.append('municipalities_no', (values.municipalities_no && values.municipalities_no.length >= 1) ? values.municipalities_no.map(region => region.value).join(',') : '');
      gameData.append('activities', (values.NAC_codes && values.NAC_codes.length >= 1) ? values.NAC_codes.map(code => code.value).join(',') : '');
      gameData.append('cashback_percentage', values.cashback_percentage || '');
      gameData.append('cashback_apply', values.cashback_apply || '');
      gameData.append('type', 'cashback');
      gameData.append('receipt_type', serializeGameReceiptTypes(values.receipt_type));
      gameData.append('start_date', start_date || '');
      gameData.append('end_date', end_date || '');
      gameData.append('isYearly', values.isYearly || false);
      gameData.append('protocol_number', values.protocol_number || '');
      gameData.append('limit', values.limit || '');

      if (values.file) {
        gameData.append('file', values.file);
      }

      await createGame(gameData).unwrap();
      toast.success("Loja u krijua me sukses!");
      setTimeout(() => {
        navigate('/games')
      }, [1000])
    } catch (error) {
      toast.error("Krijimi i lojës dështoi!");
      console.error("Failed to create game:", error);
    }

    setSubmitting(false);
  };

  const details = {
    title: 'Krijo lojë cashback'
  }

  return (
    <>
      <CreateGame isCashback={true} details={details} handleSubmit={handleFormSubmit} />
    </>
  );
}